import { render } from "./VabeneTopProduitReportSell.vue?vue&type=template&id=1777db3d&ts=true"
import script from "./VabeneTopProduitReportSell.vue?vue&type=script&lang=ts"
export * from "./VabeneTopProduitReportSell.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__